import type { SVGProps } from 'react';

const SvgHowToVote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v6h18v-6zm1.81-5.04L13.45 1.6 5.68 9.36l6.36 6.36zm-6.35-3.55L17 7.95l-4.95 4.95-3.54-3.54z" />
  </svg>
);
export default SvgHowToVote;
